export const token =
  "eyJraWQiOiJITUhkS2FoQSt0NnU0S3BtZjVNaFwvWGg4R1BUKyt4YllFRlhPNmY0N0pBST0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5N2FjODM5NS1lNTllLTRlODAtODRkMC00YTU5MGVhMmRkYmEiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0yLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMl9ZUExzVWkweFUiLCJ2ZXJzaW9uIjoyLCJjbGllbnRfaWQiOiI3bG80YzVsbmk5czVkdjlocW1iZDlyc2dlaiIsImV2ZW50X2lkIjoiOWY3MTg2ZjQtMTFkYS00MWExLTg3MjEtMTExM2Y1MmMzNjA3IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiBwaG9uZSBvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImF1dGhfdGltZSI6MTY1NDY3OTA5NywiZXhwIjoxNjU0NjgyNjk3LCJpYXQiOjE2NTQ2NzkwOTgsImp0aSI6Ijc4NDlmY2MzLTI5M2YtNDI5ZC1hOTIzLTExZWFjMGZhN2M2MSIsInVzZXJuYW1lIjoibmlraGlsc3A4NTUifQ.enY9E7o5AT0ueUIebFsZVKgUbfm9K0jZ_2-QehrkAqO6ihv1xk020xXmKZQTQdAT74iPLqEgve8JO_LEqyos473UE7TR2_mZZeV4Jp8QMD9L-t_OsAWsLyLqF9aj3mE3ncwcYi8U4B2VchCz-2KnOmWUp-fLAKBRuVDXjQUDuOijjVCNACW32zmYIndvKAFO4Bh1VFsOyBXLMedTV5TtMALG85rJsqi9IbDf_DgDkWt5iYld3EIwcWF4XPKm-GhrkMxMqCaAvON5Kz0szaWC5lQFUp2Q-InMCkefiWJMIWoNIxp-xMCPm223GGBtHHrNg1eIX4Z2H7OBYczGJiQqHw";
export const APPLY_LOAN =
  "https://secure1.capexmd.com:4443/LoanApplicationSystem/usf-prequalification-request.php";
export const PATH_COGNITO_SIGNIN =
  "https://usf-felix-ui-qa.auth.us-east-2.amazoncognito.com/login?client_id=1q41gq3hvck5ufonif5dhta59k&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Fd29s3ndany2t3o.cloudfront.net%2F";
export const SECRET_KEY = "tfGHheui/DXFTs43dfHJ#ghTGYHhvyfvrG@183";
export const MSG_TXT1 = `If you need immediate1 assistance, call  954-247-620  or if this is a medical emergency, please call 911.`;
export const MSG_TXT2 =
  "Messaging should be used for rotuine matters only and not for urgent concerns, Messages are monitored and will be responded to by 2 business days.";
export const msgConfig = [
  {
    title: "INBOX",
    url: "/messages/inbox",
    text: "Inbox",
    icon: "/Assets/payment.png"
  },
  // {
  //   title: "DRAFTS",
  //   url: "/messages/drafts",
  //   text: "Drafts",
  //   icon: "/Assets/payment.png"
  // },
  // {
  //   title: "SENT",
  //   url: "/messages/sent",
  //   text: "Sent",
  //   icon: "/Assets/payment.png"
  // },

  {
    title: "DELETED",
    url: "/messages/deleted",
    text: "Deleted",
    icon: "/Assets/payment.png"
  }
];

const xsValue = [
  {
    len: 3,
    value: 4
  },
  {
    len: 2,
    value: 6
  },
  {
    len: 1,
    value: 12
  }
];

const boxContainerData = [
  { programCount: 4, minHeight: 230 },
  { programCount: 5, minHeight: 300 },
  { programCount: 6, minHeight: 330 }
];
export const getBarContainerHeight = (programLength) => {
  let height;
  boxContainerData.map((item) => {
    if (item.programCount === programLength) {
      height = item.minHeight;
    }
  });
  return height;
};

export const loanDisclaimer = `Qualified applicants may be approved for a 24 to 84 month
term with varying APR ranges based upon credit profile. Eligibility for a loan is not
guaranteed. All loan applications are subject to credit review and approval and offered
loan terms depend upon the applicant's credit score, requested amount, requested loan
term, and credit usage and history. Not all borrowers receive the lowest interest rate.
Rates and terms are subject to change at any time without prior notice.`;

export const fapCardsStore = {
  programVisualization: [
    {
      boxNumber: "PC-9",
      boxName: "Refund Program",
      buttonText: "Select The Refund Program",
      selected: false,
      createdBy: null,
      programs: [
        {
          programId: "PI-27",
          programName: "1 cycle refund",
          noOfCycle: 2,
          refund: false,
          effectiveDate: null,
          programPrice: 9000,
          selected: false
        },
        {
          programId: "PI-28",
          programName: "2 cycle refund",
          noOfCycle: 2,
          refund: false,
          effectiveDate: null,
          programPrice: 9455,
          selected: false
        },
        {
          programId: "PI-28",
          programName: "2 cycle refund",
          noOfCycle: 2,
          refund: false,
          effectiveDate: null,
          programPrice: 11100,
          selected: false
        }
      ]
    },
    {
      boxNumber: "PC-5",
      boxName: "Non-Refund Program",
      buttonText: "Select The Multi-CycleDiscount Program",
      selected: false,
      createdBy: null,
      programs: [
        {
          programId: "PI-12",
          programName: "1 cycle  refund",
          noOfCycle: 1,
          refund: false,
          effectiveDate: null,
          programPrice: 6167,
          selected: false
        },
        {
          programId: "PI-12",
          programName: "2 cycle  refund",
          noOfCycle: 1,
          refund: false,
          effectiveDate: null,
          programPrice: 7500,
          selected: false
        }
      ]
    },

    {
      boxNumber: null,
      boxName: "Single cycle",
      buttonText: "Select The Pay per Cycle Treatment Plan ",
      selected: false,
      createdBy: null,
      programs: [
        {
          programId: null,
          programName: "1 cycle",
          noOfCycle: 1,
          refund: false,
          effectiveDate: null,
          programPrice: 18100,
          selected: false
        },
        {
          programId: null,
          programName: "2 cycle",
          noOfCycle: 3,
          refund: false,
          effectiveDate: null,
          programPrice: 36100,
          selected: false
        },
        {
          programId: null,
          programName: "3 cycle",
          noOfCycle: 3,
          refund: false,
          effectiveDate: null,
          programPrice: 54100,
          selected: false
        },
        {
          programId: null,
          programName: "4 cycle",
          noOfCycle: 4,
          refund: false,
          effectiveDate: null,
          programPrice: 54100,
          selected: false
        },
        {
          programId: null,
          programName: "4 cycle",
          noOfCycle: 4,
          refund: false,
          effectiveDate: null,
          programPrice: 54100,
          selected: false
        },
        {
          programId: null,
          programName: "5 cycle",
          noOfCycle: 5,
          refund: false,
          effectiveDate: null,
          programPrice: 54100,
          selected: false
        }
      ]
    }
  ],
  globalPriceOfFet: 1600,
  discountedGlobalTpPrice: 4000
};

export const fapViewProgram = {
  "Refund Program": {
    programSummary: "Bring home a baby or receive a refund",
    discountStr: "Significantly discounted bundled pricing",
    programLabel: "Unlimited Frozen Embryo Transfers",
    programLabel1: "Multiple Retrievals"
  },
  "Non-Refund Program": {
    programSummary: "Embryo banking allowed",
    discountStr: "Discounted bundled pricing",
    programLabel: "Unlimited Frozen Embryo Transfers",
    programLabel1: "Multiple Retrievals"
  },
  "Single cycle": {
    programSummary: "Pay for treatments as needed",
    discountStr: "Discounted bundled pricing unavailable",
    programLabel: "1 Frozen Transfer Per Cycle"
  },
  "Pay Per Cycle": {
    programSummary: "Pay for treatments as needed",
    discountStr: "Discounted bundled pricing unavailable",
    programLabel: ""
  }
};
export const fapViewProgramFP = {
  "Refund Program": {
    programSummary: "Bring home a baby or receive a refund",
    discountStr: "Significantly discounted bundled pricing",
    programLabel:
      "Freeze 20/30 eggs or complete up to 4/5 egg freezing cycles, whichever occurs first"
  },
  "Non-Refund Program": {
    programSummary: "Discounted bundled pricing",
    discountStr:
      "Up to 5 Egg Freezing cycles available for the opportunity to freeze up to 30+ eggs",
    programLabel:
      "Freeze 20/30 eggs or complete up to 4/5 egg freezing cycles, whichever occurs first"
  },

  "Pay Per Cycle": {
    programSummary: "Discounted bundled pricing not available",
    discountStr:
      "Pay for treatment as you go, no cap if multiple cycles are needed to achieve desired results",
    //programLabel: "1 Frozen Transfer Per Cycle"
    programLabel: ""
  }
};
export const programBoxName = {
  SINGLE_CYCLE: "Single cycle",
  REFUND_PROGRAM: "Refund Program",
  NON_REFUND_PROGRAM: "Non-Refund Program",
  PAY_PER_CYCLE: "Pay Per Cycle"
};
// const correctBoxName = {
//   "Single cycle" : "Single Cycle"
//   "Refund Program" : "Refund Program",
//   "Non-Refund Program" :
// };
// export const getProgramName =(programName)=>{

// }

export const getXsValue = (len) => {
  let val;
  xsValue.map((item) => {
    if (item.len === len) {
      val = item.value;
    }
  });
  return val;
};

//Home
export const tasks = [
  {
    label: "Registration and Login",
    status: "completed",
    step: 1,
    infoName: "reviewEstimate"
  },
  {
    label: "Meet with your Financial Counselor",
    status: "estimateStatus",
    step: 2,
    infoName: "estimateStatus"
  },
  { label: "Review Estimate", status: "reviewEstimateStatus", step: 3, infoName: "selectProgram" },
  { label: "Select Program", status: "selectProgramStatus", step: 4, infoName: "contractPayBill" },
  {
    label: "Sign the Contract",
    status: "contractSignStatus",
    step: 5,
    infoName: "contractPayBill"
  },
  { label: "Pay your Bill", status: "payBillStatus", step: 6, infoName: "" }
];

// Next Steps
export const fAQs = [
  {
    id: 1,
    question: "How many total cycles do I have with the Fertility Access program?",
    answer:
      "We offer Multi-Cycle Discount and Refund Programs with either 2 or 3 retrieval cycles, the selection is yours to make. All programs include unlimited embryo transfers until you bring home a baby."
  },
  {
    id: 2,
    question: "How do you define success?",
    answer: "Success means bring home a baby. Once you bring home a baby, the program is completed."
  },
  {
    id: 3,
    question: "What if I get pregnant and deliver a baby after my first cycle?",
    answer:
      "You will have been successful! The terms of the program will have been satisfied and you will not be refunded for any unused benefits or apply those unused benefits toward a new cycle in the future."
  },
  {
    id: 4,
    question: "When is payment due, once a decision is made to enroll?",
    answer:
      "Payment in full is due 2 weeks before you start the injectable medications for the first IVF cycle. Please note, if needed, enrollments can be expedited within the 2-week timeframe."
  },
  {
    id: 5,
    question: "Can I withdraw from the program?",
    answer:
      "Yes, we recognize that plans can change, and we allow patients to withdraw from the programs before treatment begins or between cycles if you are not successful. Terms vary based on whether you select a Refund Program or Multi-Cycle Discount Program as outlined in your contract."
  },
  {
    id: 6,
    question: "Are medications included?",
    answer: "Medications are not included in the program"
  },
  {
    id: 7,
    question: "Is PGT-A testing Included?",
    answer:
      "It is offered as an additional bundle where possible.  Ask your Fertility Access Concierge for additional details."
  },
  {
    id: 8,
    question: "What are the advantages of the PGT-A Analysis Unlimited™ program?",
    answer:
      "•  Unlimited PGT-A analyses throughout your journey until you take home a baby • One-time fixed cost with no hidden fees  •  Financing options available"
  },
  {
    id: 9,
    question: "Who qualifies for the PGT-A Analysis Unlimited™ program?",
    answer:
      "Individuals who do not have insurance coverage for PGT-A analysis qualify for the program."
  },
  {
    id: 10,
    question:
      "Do I have to be enrolled in a Fertility Access multi-cycle discount or refund program to take advantage of the PGT-A Analysis Unlimited™ program?",
    answer: "No. You can enroll in the program without being enrolled in other IVF bundles."
  },
  {
    id: 11,
    question: "Is other genetic testing beyond PGT-A covered in this program?",
    answer: "No. The PGT-A Analysis Unlimited™ program only covers PGT-A genetic testing."
  },
  {
    id: 12,
    question: "How long do I have to decide if I want to enroll?",
    answer:
      "You would need to enroll 2 weeks prior to the start of the injectable medications for the first IVF cycle within 60 days of the contract issue date, whichever comes ﬁrst. Please call Fertility Access at 1-800-873-9203 if you require a contract extension."
  },
  {
    id: 13,
    question: "If I enroll in a Refund program, when am I eligible for a refund?",
    answer:
      "If you complete all cycles, have transferred all embryos from each retrieval and do not bring home a baby, you will be eligible for a refund. You are also eligible for a refund if you are not pregnant and choose to withdraw from the program between retrieval cycles once all embryos have been transferred. Please see specific terms and conditions in the contract."
  },
  {
    id: 14,
    question: "How can Fertility Access help me?",
    answer:
      "Fertility Access offers a variety of IVF Refund and Multi-Cycle Discount Programs that offer significant savings by bundling reduced fees upfront. Our programs also provide peace of mind, with refund options in the event treatment is unsuccessful. There are multiple options to suit patients’ unique treatment and financial needs."
  },
  {
    id: 15,
    question:
      "Why should I enroll in a Fertility Access program rather than just pay for one cycle at a time?",
    answer:
      "Unfortunately, the reality of infertility treatment is that sometimes it takes more than one treatment cycle to achieve success. However, the good news is 80% of participants who complete the Fertility Access program take home a baby. In traditional pay-per-cycle plans, in order to try again, you must pay again. With Fertility Access, prepayment offers significant savings and makes it much more efficient to start a new cycle should that be necessary. All the while, your physician is working with you to make treatment adjustments to optimize your chance of success."
  },
  {
    id: 16,
    question: "How does Fertility Access work with my insurance benefits?",
    answer:
      "The Fertility Access programs are designed for patients no health insurance coverage for IVF treatment.   However, if you have a limited amount of insurance coverage, you may still benefit from the Fertility Access programs."
  },
  {
    id: 17,
    question:
      "If I enroll in an IVF Refund or Multi-Cycle Discount Program, will it affect my treatment plan?",
    answer:
      "There is absolutely no impact on the treatment plan your doctor created for you. You will receive the same care that you would if you were to pay for treatment one cycle at a time."
  },
  {
    id: 18,
    question: "How do I apply?",
    answer:
      "There is nothing for you to do other than ask your Financial Counselor or a Fertility Access Patient Concierge to apply on your behalf. Most patients have already completed all necessary tests: if not, you will be informed if any additional testing is necessary."
  },
  {
    id: 19,
    question: "Is there an application fee?",
    answer:
      "There is no cost to apply and no obligation to enroll. We encourage all patients to apply to explore all of their options."
  },
  {
    id: 20,
    question: "What happens after my application is submitted?",
    answer:
      "The Fertility Access clinical team will review your application to determine your eligibility. This review typically takes 24 to 48 business hours. If your doctor recommends IVF, you are automatically eligible for the Multi-Cycle Discount Program. The clinical team will determine if you are also eligible for the IVF Refund Programs."
  },
  {
    id: 21,
    question: "How does Fertility Access determine eligibility?",
    answer:
      "Our goal is to help you achieve the family of your dreams with as few financial barriers as possible. However, in order to keep our programs affordable, the Refund Programs have eligibility criteria such as age and medical history requirements, to name a few.  However, all patients qualify for the Multi-Cycle Discount Program."
  },
  {
    id: 22,
    question: "Do the cycles have a completion timeline?",
    answer:
      "In general, we ask that the program be completed within 36 months. All of this will be fully explained in your contract and of course, your Fertility Access Patient Concierge can answer any questions."
  },
  {
    id: 23,
    question:
      "I see that the programs include unlimited frozen embryo transfers, what does this mean?",
    answer:
      "Following a fresh IVF cycle, there may be high quality embryos left over, unused, that make great candidates for vitrification (flash freezing) for future pregnancy attempts. An FET is a cycle in which a frozen embryo(s) is thawed and then transferred back into a woman’s uterus. The success rates of an FET cycle are at least comparable if not higher than fresh cycles, as FETs offer an opportunity to optimize the lining of the uterus before implantation in subsequent cycles, plus they require less medication and are generally considered easier and more convenient."
  },
  {
    id: 24,
    question: "How do I enroll in a Fertility Access program?",
    answer:
      "Once you have decided which Fertility Access program is right for you, make a selection in your estimate and a contract will be sent to your documents section of your portal to review and sign. Submit payment, and you will be ready to start your treatment."
  },
  {
    id: 25,
    question:
      "Can I select teh PGT-A Analysis Unlimited Program if I am not doing the Multi-Cycle or Refund program?",
    answer:
      "Yes, you can select to bundle your PGT-A testing if you are not doing another Fertility Access Program for your IVF cycles. This program offers unlimited PGTA-A Analysis until you take home a baby, so there are no surprise costs tied to your PGT-A testing."
  }
];

export const fertilityReasons = [
  {
    id: 1,
    title: "Easy access.",
    info: "Fertility Access makes paying for IVF treatment simple and stress-free, so you can focus on building your family."
  },
  {
    id: 2,
    title: "Track record of success.",
    info: "80% of patients who complete the program take home a baby."
  },
  {
    id: 3,
    title: "Peace of mind.",
    info: "With the cost of treatment taken care of, you can focus on what’s most important - building your family!"
  },
  {
    id: 4,
    title: "Savings.",
    info: "Purchasing multiple cycles up front with Fertility Access can save you thousands of dollars and keep you in treatment long enough to be successful."
  }
];

export const fertilityMsg =
  "If you select a Fertility Access program, you will be sent a contract in your portal to review and sign as well as your payment options. If you opt for single cycle treatment you will pay the practice directly.";

export const fertilityAccessInfo =
  "Each year, thousands of people become parents through in-vitro fertilization (IVF). While IVF is an excellent way to overcome infertility, it’s important to realize that most patients require more than one cycle to be successful. We offer Multi-Cycle Discount and Refund Programs through Fertility Access. These programs have proven to increase your chances of having a baby by providing you with multiple cycles for a single, discounted fee. If treatment is not successful, you may be eligible for a refund, preserving your financial resources for other family building options. \n\n We believe this is the best path forward for many patients, for many reasons. These programs are designed to help patients with little to no insurance coverage overcome the financial barriers associated with IVF. The bundled options offered by Fertility Access make paying for treatment easy to understand and affordable. Costs are explained up front to remove sudden and hidden fees during the treatment process. The result? Peace of mind and a treatment journey that is as stress-free as possible. \n\n While your doctor will assign a treatment plan that is unique to you, there is a Multi-Cycle Discount or Refund Program designed to accommodate whatever your needs may be. An additional benefit of the bundled, discounted programs offered by Fertility Access is that they include unlimited frozen embryo transfers after retrieval, included in the Program fee. This can save patients a tremendous amount over time as often more than one transfer is needed.";

//homepage
export const infoHeader = "Are you ready to take the next step?";
export const infoSubHeader =
  "Thank you for trusting us with your care. We are honored to accompany you on this journey. To help determine the best program available for the treatment plan decided by your provider. Please know your estimate published by your Financial Counsellor.";
export const contactTxt = "If you have any questions,send us a message or call 954-247-6200.";

export const callTxt = " To speak with a help desk associate, call 954-247-6200.";
export const knowEstimateheader = "EXPLORING FINANCING OPTIONS";
export const knowEstimateTxt =
  " Now that you've completed your evaluation, your physician will work with you to develop a treatment plan that is personalized for you. Discuss costs with a financial counselor.";
export const knowEstimateInfo =
  "There are many financial options to consider as you go through the journey of building your family. Some patients turn to medical loans, others take advantage of payment programs. There are a range of resources available to help manage the costs of infertility treatment.";
export const assistTxt = "Need Immediate Assistance?";
export const sendMsgTxt = "Please send us a message.";

export const goalTxt =
  "Our goal is to provide you with the ultimate patient experience. A large part of that is knowing your personal information is safe, secure and easily accessible.";
export const secureMsgTxt =
  " The ability to communicate with your clinical care team and financial team in a secure environment.";
export const treatmentTxt =
  "The access to view your Treatment Estimate published by your Financial Counsellor.";
export const welcomeTxt = "Welcome to your patient portal.";
export const addressTxt = "2960 NORTH STATE ROAD 7 SUITE 300 MARGATE, FL 33063";
export const goalTxt1 =
  "Our goal is to provide you with the ultimate patient experience. A large part of that is knowing your personal information is safe, secure and easily accessible. We understand that the dream of building a family never sleeps, which is why we'll be here for you twenty four hours a day, seven days a week.";
export const callNo = "954-247-6200";
export const timeInfo =
  "Monday-Friday : 7:00 am to 4:30 pm Saturday, Sunday & Holiday : 7:00 am to 9:00 am Saturday, Sunday & Holiday : 7:00 am to 9:00 am";

export const IVF =
  "The key element of the IVF process involves fertilization of the eggs 'In vitro' which means outside of the body. Eggs collected directly from the ovaries are combined with sperm in the laboratory to create embryos, which are then grown and nurtured in specialized incubators for three to five days before the best of the group is selected for transfer into the uterus.";

export const InitialValuesForMessage = {
  messageId: null,
  conversationId: null,
  subject: "",
  body: "",
  type: null,
  fromUserId: "",
  assignedTo: null,
  assignedToName: null,
  patientFirstName: null,
  patientLastName: null,
  status: "",
  hasAttachment: false,
  notes: null,
  srcMessageId: null,
  sentDate: null,
  updationDate: null,
  messageAttachment: [],
  messageRecipient: []
};
export const knowEstimateSubheader =
  "Thank you for trusting us with your care.We are honored to accompany you on this journey. To help determine the best course of treatment, please complete your diagnostic testing.";

export const infoData = {
  reviewEstimate: {
    header: "Your Treatment Plan Estimate is ready.",
    subHeader: "Your Treatment plan has been created and is ready for your review.",
    button: [{ link: "/treatment-estimate", name: "Review Estimate" }]
  },
  selectProgram: {
    header: "Your Estimate is Ready, Select the Program.",
    subHeader:
      "Since your estimate is ready and published by your Financial Counsellor. Please select the appropriate program.",
    button: [{ link: "/treatment-estimate", name: "Select Your Program" }]
  },
  contractPayBill: {
    header: "Your Contract and Invoice are ready.",
    subHeader:
      "You Contract and Invoice are ready for the program selected by you. Please review and sign the contract also complete the payment formalities so that we can start your treatment.",
    button: [
      { link: "/document-management", name: "Sign the Contract" },
      { link: "/pay-your-bill", name: "Pay Your Bill" }
    ]
  }
};
export const footerTerms = [
  {
    name: "Terms of Use & Privacy Policy",
    link: "/terms-and-conditions"
  }
  // {
  //   name: "Terms & Conditions",
  //   link: "/terms-and-conditions"
  // },
  // {
  //   name: "Privacy Policy",
  //   link: "/privacy-policy"
  // },
  // {
  //   name: "Notice & Pharmacy Practices",
  //   link: "/notice-and-practices"
  // }
];
export const footerItems = [
  {
    name: "Home",
    link: "/home"
  },
  {
    name: "Treatment Estimate",
    link: "/treatment-estimate"
  },
  {
    name: "Document Management",
    link: "/document-management"
  },
  {
    name: "Pay Your Bill",
    link: "/pay-your-bill"
  },
  {
    name: "Contact Us",
    link: "/messages/inbox"
  },
  {
    name: "Clinical Portal",
    link: "/clinical-portal"
  },
  {
    name: "Profile",
    link: "/profile/info"
  }
];
export const footerContact = {
  label: "Contact",
  contactNo: "954-247-620"
};
export const MSG = {
  SAVED_SUCCESSFULLY: "Saved Successfully",
  UPDATED_SUCCESSFULLY: "Updated Successfully",
  DELETED_SUCCESSFULLY: "Deleted Successfully",
  APPROVED_SUCCESSFULLY: "Application Approved",
  DENIED_SUCCESSFULLY: "Application Denied",
  NOTE_SAVED: "Note Saved Successfully"
};

export const LoginUrl = "https://usf-dev-felix-ui.auth.us-east-2.amazoncognito.com";
//"https://usf-demo-felix-ui.auth.us-east-2.amazoncognito.com/login?response_type=token&client_id=3v3dcl92vd7it51flabd5j4lo8&redirect_uri=http://localhost:3000/&scope=aws.cognito.signin.user.admin+email+openid+phone+profile"; // demo
// "https://usf-qa-felix-ui.auth.us-east-2.amazoncognito.com/login?client_id=1valvb3t9un7pvvfe2ie965kha&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://d29s3ndany2t3o.cloudfront.net"; //QA

export const LogoutUrl =
  "https://usf-dev-felix-ui.auth.us-east-2.amazoncognito.com/logout?client_id=2s0tj2bmfvb0q505qhttgsbjl0&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://d2zwrmed259hd0.cloudfront.net/";
export const getQueryString = (obj) => {
  let str = "";
  for (var key in obj) {
    if (obj[key] != "" && obj[key] != "default") {
      if (str != "") {
        str += "&";
      }
      str += key + "=" + obj[key];
    }
  }
  return "?" + str;
};
const gender = { F: "Female", M: "Male" };
export const getGengerFullName = (sex) => {
  return gender[sex];
};
export const PAY_BILL =
  "https://z4-ppw.phreesia.net/z4/patient/Payment.aspx/Start?encrypted=q9sKxl0EhHhxeKSIBYpiHrbc5Lx-vkikh_MQb69YXqTNEBE9f0IfQTt5sGxjDt1qyYj9s_Rg2Y8lnnSKen3TN7DI3yqy7BK_WkgwQfgin-gn6WshvBDb10yYTf2cNcaq1chwN0Y8OOdfiw_VUWvl48RkP6OPSKf5-bN-85YBqZ01";
export const privacyPolicy =
  "Please read this Privacy Policy carefully. This Privacy Policy is subject to the Terms and Conditions posted on this Portal and may be amended without notice. Any changes to this Privacy Policy will be effective immediately upon the posting of the revised Privacy Policy on this portal.  Portal users are encouraged to periodically check this policy to see if any changes have been made that may affect them. By using the IntegraMed Fertility Patient Portal, you agree to the terms of this Privacy Policy. \n\n Personal-identifying information is data that can be used to identify or contact you.  The IntegraMed Fertility Patient Portal collects only the personal-identifying information you provide to us through web pages at  Learn more at www.FertilityAccessProgram.com (the 'Portal'), such as when you use certain features of the Portal, such as making an appointment or emailing general inquiries to the practice. All personal-identifying information, however collected, is used only by the IntegraMed Fertility Patient Portal for the sole purpose of acting as requested by the user and responding to the user, and is not disclosed to any third parties. This Privacy Policy does not apply to any other data, including, without limitation, data that the IntegraMed Fertility Patient Portal may collect on websites that may be linked to the Portal. \n\n The IntegraMed Fertility Patient Portal  reserves the right to disclose any personally identifying or non-personal identifying information collected through the Portal if we are required to do so by law or if we reasonably believe that such action is necessary in order to: fulfill a government request, conform with the requirements of the law or to comply with legal process served on us; protect against misuse or unauthorized use of the Portal; transfer to a successor entity in connection with a corporate merger, consolidation, sale of assets or other corporate change respecting IntegraMed America, Inc. ('IntegraMed')  or this Portal; protect or defend the legal rights or property of IntegraMed America, Inc., this Portal or its users; or, in an emergency, to protect the health and safety of this Portal’s users or the general public.\n\n We may also collect non-personal-identifying information through the use of 'cookies', which are small text files stored on your computer’s hard drive or web server and are used to aid in web page navigation. The IntegraMed Fertility Patient Portal does not store any personal identifying information in any cookies on your computer. Portal users have the option whether or not to accept cookies by resetting their web browsers to give notice when a cookie is being sent to their hard drive. Cookies may also be deleted from a hard drive, however, some parts of this Portal may not function properly or may be slowed considerably if cookies are not accepted or disabled. \n\n This Portal is not intended for use by minors. The IntegraMed Fertility Patient Portal does not knowingly allow anyone 18 years of age, unless legally emancipated to participate in any activity on the Portal. {name} does not provide services outside of the United States. If you are located outside of the United States, by submitting information to the IntegraMed Fertility Patient Portal you are consenting to the transfer of your data to the United States and our processing of your data in the United States in accordance with this Privacy Policy.\n\n A Notice of Privacy Practices pursuant to the Health Insurance Portability and Accountability Act of 1996 ('HIPAA') is made available at the time any prospective or actual patient first receives services from their selected IntegraMed Fertility network practice. \n\n While reasonable steps have been taken to ensure the security of the IntegraMed Fertility Patient Portal infrastructure and data, we make no guarantees or warranties concerning the security of any information you disclose or transmit to us online and cannot be responsible for the theft, destruction or inadvertent disclosure of personally identifiable information. \n In the course of developing IntegraMed business, IntegraMed may buy or sell assets. If another entity acquires IntegraMed or all or substantially all of its assets, personally identifiable information and other information collected from users of the Portal may be transferred to the entity as one of the transferred assets. If any bankruptcy or reorganization proceeding is brought by or against IntegraMed, all such information may be considered an asset of IntegraMed and as such may be sold or transferred to third parties.\n\n Upon request we provide Portal visitors with access to a description of information that we maintain about them and offer visitors the ability to have inaccuracies corrected in contact information. Portal users can have this information corrected by writing to us at the below address. \n\n If you have any questions about this Privacy Policy please contact:\n\n";

export const termsConditions =
  "US Fertility has developed a password-controlled, restricted access, secure patient portal that allows US Fertility network practice patients to have secure, electronic access to select portions of their medical record and to communicate with their network practice via secure messaging and other means. The following are the Terms and Conditions of use of the US Fertility Patient Portal. Please read them carefully. By logging onto the US Fertility Patient Portal the first time and each subsequent log-on, you confirm that you are eligible to access the US Fertility Patient Portal and you agree to observe and be bound by all these Terms and Conditions as may be amended from time to time.\n\n Because the US Fertility Patient Portal will continually evolve and because we may change, supplement or delete any of its functions, we reserve the right to modify these Terms and Conditions. Questions concerning the US Fertility Patient Portal or its operation should be directed to your US Fertility network practice. The US Fertility Patient Portal is provided AS IS and AS AVAILABLE. We assume no responsibility for the timeliness, deletion, mis-delivery or failure to store any of your information.";
export const acknowledge = [
  {
    id: 1,
    info: "You are at least 18 years of age, or legally emancipated"
  },
  {
    id: 2,
    info: "You will use the US Fertility Patient Portal only to communicate on behalf of yourself, or someone else for whom you are legally authorized"
  },
  {
    id: 3,
    info: "All personal information you enter in US Fertility Patient Portal on behalf of yourself or someone else is true and correct and that you will not impersonate or attempt to impersonate someone else"
  },
  {
    id: 4,
    info: "You understand that by using the US Fertility Patient Portal, you will receive messages to the email address you provided to your practice from the system for various events; including notification of new secure messages, lab results, etc. as well as reminders for upcoming appointments, and, that in order to not receive these messages, you would need to dis-enroll from the service which can be accomplished by contacting your practice"
  }
];
export const requirements = [
  {
    id: 1,
    title: "Web Browser",
    info: "The US Fertility Patient Portal will work best with the latest version of: Mozilla Firefox, Chrome, Safari, Microsoft Edge or Microsoft Internet Explorer 11."
  },
  {
    id: 2,
    title: "Javascript and Cookies",
    info: "You must enable Javascript and Cookies in your web browser to use the US Fertility Patient Portal. Cookies are used solely to maintain your 'session' while you are logged in to the US Fertility Patient Portal. Cookies from the US Fertility Patient Portal do not contain protected health information ('PHI')."
  },
  {
    id: 3,
    title: "Working Email Account",
    info: "You must have access to a personal email account in order to receive important notifications and reminders from the US Fertility Patient Portal. It is important to note that your email service may mistakenly mark email notifications from US Fertility Patient Portal as spam. To ensure delivery of your notifications, you should allow receipt of email from the email address 'donotreply@myhealthpatientportal.com'."
  },
  {
    id: 4,
    title: "Internet Access",
    info: "You must have Internet access to use the US Fertility Patient Portal. The US Fertility Patient Portal will work best on high-speed connections."
  }
];
export const risksInclude =
  "Your personal health information may be disclosed to an unauthorized party if you leave your computer while logged in, share your password, or if your password is stolen from you.\n\n The information you view through the US Fertility Patient Portal may be corrupted, incomplete, delayed, interrupted, or otherwise not delivered. The most up to date information in your file with the practice is always available by calling or visiting the practice in person.";
export const securityConfidentiality = [
  {
    id: 1,
    title: "Password Protection",
    info: "You must keep your password and your patient account number (MPI#) confidential. Do not share your password with anyone. If someone obtains your password, they will have access to all your medical information and be able to communicate with the practice on your behalf.\n\n If at any point you believe your password has been compromised, you should change it immediately by logging in and accessing 'Account Settings' under your 'Profile'."
  },
  {
    id: 2,
    title: "Sign-Up and Verification of Identity",
    info: "To sign up for and use the US Fertility Patient Portal, you will be asked to enter your patient account number and birth date for enrollment into the portal. Once the patient account number, birth date and additional confidential information about yourself are entered and a user ID and password are established, the system has a set of criteria to authenticate the user."
  },
  {
    id: 3,
    title: "Encryption",
    info: "Upon creation of user authentication ID and password and implementation of the aforementioned requirements, any information entered into the US Fertility Patient Portal regarding access or personal health information, will be encrypted and stored in the patient portal database using hash value algorithms."
  }
];
export const usage = [
  {
    id: 1,
    title:
      "Do not use the US Fertility Patient Portal for Matters Requiring Urgent Medical Attention",
    info: "IF YOU ARE EXPERIENCING A MEDICAL EMERGENCY, CONTACT 911. DO NOT USE the US Fertility Patient Portal TO SEND ANY MESSAGES OR REQUESTS THAT REQUIRE URGENT MEDICAL ATTENTION.\n If the content of your message or request is non-urgent but you require a response within 2 business days, call the practice directly."
  },
  {
    id: 2,
    title: "Maintain a Current Email Account",
    info: "You must keep your email address current and have access to that email address. If you need to change your email address, contact your practice. The practice may still continue to communicate with you via phone, fax, or postal service. It is at the practice's discretion which messages are communicated to you through the US Fertility Patient Portal."
  },
  {
    id: 3,
    title: "Types of Messages You May Receive",
    info: "You may receive secure messages from the practice that contain test results, information about procedures or surgery, and other important medical information."
  },
  {
    id: 4,
    title: "When You Do Not Receive a Message",
    info: "If you do not receive a response to a secure message or request that you have sent the practice, it is your responsibility to contact the practice by phone or in person. NEITHER THE PRACTICE NOR US FERTILITY IS RESPONSIBLE IF YOU DO NOT READ YOUR MESSAGES OR IF YOUR EMAIL ADDRESS ON FILE BECOMES INVALID OR UNREACHABLE. NEITHER US FERTILITY NOR THE PRACTICE WILL BE LIABLE FOR ANY LOSS, INJURY, ILLNESS, DAMAGES OR CLAIMS OF ANY KIND RESULTING FROM YOUR FAILURE TO READ MESSAGES IN A TIMELY MANNER."
  },
  {
    id: 5,
    title: "Viewing Messages Sent by The Practice",
    info: "Every time you receive a secure message from the practice, you will receive a notification email at your current email address registered with the US Fertility Patient Portal. These notification emails will never contain personal health information, only generic information notifying you of an event in the US Fertility Patient Portal. To view the secure message, you must then login to the US Fertility Patient Portal. It is your responsibility to login to view the secure message."
  },
  {
    id: 6,
    title: "Acceptable Content",
    info: "You agree not to use the US Fertility Patient Portal to send any illicit or offensive material."
  },
  {
    id: 7,
    title: "How Your Messages are Routed in The Practice",
    info: "Your secure messages and requests will be automatically routed to the appropriate department in the practice as necessary for handling. It is our practice to triage messages as they are delivered, to ensure they are given proper priority. As such your message may be viewed and responded to by employees of the practice other than your primary care team. Sending a secure message through the US Fertility Patient Portal may not be appropriate if the content your message is sensitive and needs to go directly to your physician."
  },
  {
    id: 8,
    title: "Responding to Messages",
    info: "In the US Fertility Patient Portal, when you respond to a secure message, your response will automatically be sent to the author of the message you are responding to, however others in any employee in the department may be able to view and respond to your message."
  },
  {
    id: 9,
    title: "US Fertility Patient Portal as a Primary Means of Communicating with You",
    info: "By signing up for and continuing to use the US Fertility Patient Portal, you are agreeing that the practice can use the US Fertility Patient Portal as the primary means to communicate with you. You may also continue to receive communications via phone, fax, or postal mail."
  },
  {
    id: 10,
    title: "Your Messages are Permanently Stored",
    info: "Any messages you send or receive are permanently stored in the US Fertility Patient Portal and may be read or accessed by staff or other providers of the practice on a need-to-know basis."
  }
];
export const discontinuingUse =
  "Discontinuing Use\n\n You may discontinue use of the US Fertility Patient Portal at any time by contacting your practice and requesting to dis-enroll from the service.\n\n The US Fertility network practice has the right to deactivate your account at any time and for any reason.\n\n Privacy Policy Both US Fertility and the US Fertility network practice take your privacy very seriously. By accepting these Terms and Conditions, you consent to the use of personally identifiable information as outlined in the Notice of Privacy Practices published on your US Fertility network practice's public website. Use of the US Fertility Patient Portal is strictly at your own risk.\n\n Warranties\n\n US Fertility Patient Portal IS OFFERED STRICTLY ON AN 'AS IS' BASIS. US FERTILITY AND THE US FERTILITY NETWORK PRACTICE MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED AS TO THE OPERATION, CONTENT, PRODUCTS OR SERVICES INCLUDED IN US Fertility Patient Portal TO THE FULLEST EXTENT PERMISSIBLE BY APPLICABLE LAW.\n\nUS FERTILITY AND THE US FERTILITY NETWORK PRACTICE HEREBY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR INFRINGEMENT.\n\n Limitation of Liability and Indemnity\n\n US Fertility and the US Fertility network practices, their respective affiliates, employees, agents, subsidiaries, subcontractors, contractors, officers and directors shall not be liable for any loss, injury, illness, damages, or claims of any kind resulting from use of the US Fertility Patient Portal service. \n\n US Fertility is a business associate (as defined by the Health Insurance Profitability and Accountability Act of 1996, Public Law 104-191 and its promulgating regulations 'HIPAA') to your US Fertility network practice. US Fertility provides the US Fertility Patient Portal service to your US Fertility network practice and as such does not offer medical advice to you. If you have a dispute arising from use of US Fertility Patient Portal, you hereby release US Fertility from all claims, demands, damages (actual and consequential) of every kind and nature, known and unknown, disclosed and undisclosed or in any way connected with such disputes. \n\n You agree to indemnify, defend, and hold harmless both US Fertility and the US Fertility network practices against all losses, liabilities, expenses, damages and costs including reasonable attorney's fees arising out of or related to any breach of these Terms and Conditions.\n\n Modification and Severability \n\n If any provision of these Terms and Conditions is determined to be invalid or unenforceable, that condition shall be deemed severable and shall not affect the validity and enforceability of any remaining conditions\n\n Governing Law \n\n The Terms of Use constitute the entire agreement between you and us relating to your use of the US Fertility Patient Portal and govern your use of the US Fertility Patient Portal, superseding any prior agreements between you and us. You expressly agree that exclusive jurisdiction for any dispute with US Fertility, in any way relating to your use of the US Fertility Patient Portal resides in the courts of the State of New York and you further agree and expressly consent to the exercise of personal jurisdiction in the courts of the State of New York in connection with any such dispute including any claim involving US Fertility or its affiliates, subsidiaries, employees, contractors, officers, directors, telecommunication providers, and content providers. These Terms of Use are governed by the internal substantive laws of the State of New York, without respect to its conflict of laws principles. If any provision of these Terms and Conditions is found to be invalid by any court having competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of these Terms of Use, which shall remain in full force and effect. No waiver of any of these Terms and Conditions shall be deemed a further or continuing waiver of such term or condition or any other term or condition.";
export const bankAddress =
  "Make payable to Fertility Access, LLC. \n\n Mail to \n\n Fertility Access, LLC \n\n 9600 Blackwell Road, Suite 500 \n\n Rockville, MD 20850 \n\n Attn: Bonnie Paul";
export const wireNo = "1-800-873-9203";
export const validateFileSize = (file) => {
  const MAX_FILE_SIZE = 10240; // 10MB
  if (!file) {
    return ["Please choose a file", true];
  }
  const fileSizeKiloBytes = file.size / 1024;
  if (fileSizeKiloBytes > MAX_FILE_SIZE) {
    return ["File size is greater than maximum limit", false];
  }
  return ["File uploaded successfully", true];
};

export const toUSAFormat = (value) => {
  if (value && value.length == 10) {
    const a = value.substring(0, 3);
    const b = value.substring(3, 6);
    const c = value.substring(6, 10);

    return a + "-" + b + "-" + c;
  } else return value;
};

export const toPhoneFormat = (value) => {
  if (value && value.length == 10) {
    const a = value.substring(0, 3);
    const b = value.substring(3, 6);
    const c = value.substring(6, 10);

    return "(" + a + ") " + b + "-" + c;
  } else return value;
};
